<template>
  <div class="home-container">
    buyOrder
    <button @click="mintNft">
      铸造nft
    </button> <br>
    <button @click="getNftList">
      获取全部的nft
    </button><br><br><br>
    我的nft列表
    <ul>
      <li v-for="item in list" :key="item.tokenID">
        <input v-model="selectNft" type="checkbox" :value="item" name="vehicle" @change="Nftchenge"> {{ item.tokenID }}
      </li>
    </ul><br><br>
    weth:{{ wethNum }}<br>
    <button @click="readweth">
      读取weth 余额
    </button><br>
    <button @click="checkapprove">
      检查WETH否授权额度
    </button><br>
    <button @click="approve">
      weth 授权
    </button><br>
    <br>
    <div>
      <button @click="makeethtoweth">
        1eth转1weth
      </button>
    </div>

    <br><br>
    
    <ul>
      <li v-for="item in selectNft" :key="item.tokenID">
        <!-- {{ item }} -->
        <button v-if="item.approveAllstates==false" :disabled="item.approveAllstates" @click="approve(item)">
          nft授权 {{ item.tokenID }}  
        </button>
        <div>
          nft{{ item.tokenID }} 价格 
          <input v-model="message" placeholder="edit me" readonly>
          <br>
        </div>
      </li>
    </ul>
    <br>
    单位：weth
    <br><br>
    <button @click="pendingbuyorder">
      挂买单
    </button>
    <br><br>
    <button @click="buyOrder">
      成交这个买单
    </button>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import {mintMyNFT,getAllList,checkapproveAll,approveAll,
getsellToken,wethbalance,ethToWeth,X2Y2allowance,X2Y2approve,getweth} from '@/contactLogic/swap/index.js';

import {AddDayTimes}  from '@/contactLogic/swap/utils.js';


let offChainOrder;
export default {
  data() {
    return {
    list:[], 
    selectNft:[],
    selectNftPrise:[],
    message:'1',
    wethNum:'0' 
    };
  },
  methods: {
    mintNft(){
      const library= this.ethersprovider;
      const account = this.ethAddress;
      const chainID =this.ethChainID;
      const tokenID=2;
      mintMyNFT(library, account, chainID,tokenID);
    },
   async getNftList(){
     const library= this.ethersprovider;
      const account = this.ethAddress;
      const chainID =this.ethChainID;

     this.$data.list = await getAllList(library, account, chainID);
     console.log(this.$data.list);

    },
    async readweth(){
      const library= this.ethersprovider;
      const account = this.ethAddress;
      const chainID =this.ethChainID;
      const result = await wethbalance(library, account, chainID);
      console.log(result);
      this.$data.wethNum=result;

    },
    async makeethtoweth(){
      const library= this.ethersprovider;
      const account = this.ethAddress;
      const chainID =this.ethChainID;
      const ethnum =1;

      const num =await  
      ethToWeth(library, account, chainID,ethnum);

    },
    async checkapprove(){
      const library= this.ethersprovider;
      const account = this.ethAddress;
      const chainID =this.ethChainID;
      const con = getweth(library, account, chainID);
      const Wethcontractaddress=con.address;

      const data = await X2Y2allowance(library, account, chainID,Wethcontractaddress);
      
      console.log(data);

      // const list = this.$data.selectNft;
      // this.$data.selectNft=[];
      // console.log('select ',list);
      // for (let index = 0; index < list.length; index++) {
      //   const element = list[index];
      //   const result  = await checkapproveAll(library, account, chainID,element.tokenAddress);
      //   element.approveAllstates=result;
        
      // }
      // console.log(this.$data.selectNft);
      // this.$data.selectNft=list;
     
     

    },
    async approve(element){
      const library= this.ethersprovider;
      const account = this.ethAddress;
      const chainID =this.ethChainID;
      const con = getweth(library, account, chainID);
      const Wethcontractaddress=con.address;
      const num=100;

      const result  = await X2Y2approve(library, account, chainID,Wethcontractaddress,num);


    },
    Nftchenge(){
      console.log(this.$data.selectNft);
      

    },
   async pendingbuyorder(){
      const library= this.ethersprovider;
      const account = this.ethAddress;
      const chainID =this.ethChainID;
      const expireTime = AddDayTimes(2);
      const web3 = this.web3;
      const Price = "1";
      const unit="weth";

    //  offChainOrder = await sellOrder(library, account, chainID,tokenId,Price,expireTime,web3);
    //  console.log(offChainOrder);
    const sellTokenCon = new  getsellToken();
    console.log("sellTokenCon",sellTokenCon);
    console.log("sellTokenCon.addnft",sellTokenCon.addnft);
    this.$data.selectNft.forEach(element => {
      const Nftcontractaddress =element.tokenAddress;
      const tokenId = element.tokenID;
      sellTokenCon.addnft(Nftcontractaddress,tokenId,Price);    
    });

    const result = await sellTokenCon.buyOrderOffer(library, account, chainID,expireTime,unit);
    console.log('offChainOrder',result);
    const data1 = await sellTokenCon.sendOrderToserver();
    console.log('server',data1);

    
    },
    async buyOrder(){
      const library= this.ethersprovider;
      const account = this.ethAddress;
      const chainID =this.ethChainID;
      const Price = "1";
      const tokenId = this.$data.selectNft[0];
      const expireTime = AddDayTimes(2);
      const web3 = this.web3;

      // const data = await buyOrder(library, account, chainID,offChainOrder,expireTime);

    }

    
  },
  mounted() {

    
  },
    computed: {
        ...mapState(['web3', 'ethersprovider', 'ethChainID', 'ethAddress']),
        isReady() {
            return this.web3 && this.ethersprovider && this.ethChainID && this.ethAddress;
        }
        
    },
};
</script>
<style lang="less" scoped>
input{
      color: black;
}
</style>
